import React from 'react';

export const OnReviewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_4544_56458)">
        <mask
          id="mask0_4544_56458"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="-1"
          width="25"
          height="25"
        >
          <rect
            x="0.373047"
            y="-0.223389"
            width="24"
            height="24"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_4544_56458)">
          <path
            d="M6.37305 21.7766C5.82305 21.7766 5.35221 21.5808 4.96055 21.1891C4.56888 20.7974 4.37305 20.3266 4.37305 19.7766V3.77661C4.37305 3.22661 4.56888 2.75578 4.96055 2.36411C5.35221 1.97244 5.82305 1.77661 6.37305 1.77661H14.373L20.373 7.77661V10.7766V13.9999C20.373 13.9999 16.968 13.2733 14.9991 13.9999C13.6782 14.4875 12.8363 14.8677 11.9991 15.9999C11.374 16.8455 11.2174 17.4713 10.9991 18.4999C10.7335 19.7517 10.9991 21.7766 10.9991 21.7766H6.37305ZM13.373 8.77661H18.373L13.373 3.77661V8.77661Z"
            fill="#C4964D"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 22C16.0542 22 14.9859 21.6755 14.0453 21.0266C13.1047 20.3776 12.4229 19.5354 12 18.5C12.4229 17.4646 13.1047 16.6224 14.0453 15.9734C14.9859 15.3245 16.0542 15 17.25 15C18.4458 15 19.5141 15.3245 20.4547 15.9734C21.3953 16.6224 22.0771 17.4646 22.5 18.5C22.0771 19.5354 21.3953 20.3776 20.4547 21.0266C19.5141 21.6755 18.4458 22 17.25 22ZM17.25 21.125C18.6997 21.125 19.875 19.9497 19.875 18.5C19.875 17.0503 18.6997 15.875 17.25 15.875C15.8003 15.875 14.625 17.0503 14.625 18.5C14.625 19.9497 15.8003 21.125 17.25 21.125Z"
          fill="#C4964D"
        />
      </g>
      <defs>
        <clipPath id="clip0_4544_56458">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
